import { useState, useEffect } from "react";
import ForgotPassword from "./ForgotPassword";
import PasswordRecovery from "./PasswordRecovery";
import SignIn from "./SignIn";
import SignUp from "./SignUp";

export default function Index() {
  const [formType, setFormType] = useState(1);
  const [passwordRecoveryCode, setPasswordRecoveryCode] = useState("");

  useEffect(() => {
    const url = window?.location?.href.toString();
    const urlCode = url.split("prc=")[1];
    if (urlCode) {
      setPasswordRecoveryCode(urlCode);
      setFormType(4);
    }
  }, []);

  return (
    <>
      {formType === 1 && (
        <>
          <SignIn setFormType={setFormType} />
        </>
      )}
      {formType === 2 && (
        <>
          <SignUp setFormType={setFormType} />
        </>
      )}
      {formType === 3 && (
        <>
          <ForgotPassword setFormType={setFormType} />
        </>
      )}
      {formType === 4 && (
        <>
          <PasswordRecovery
            setFormType={setFormType}
            passwordRecoveryCode={passwordRecoveryCode}
          />
        </>
      )}
    </>
  );
}
